import { createSelector } from "reselect"
import { chain, map, get, isEmpty, some } from "lodash"
import { Creators } from "../model"
import { getSelectedGroup } from "."
import { getDataMap } from "./data"
import { getColumns } from "./columns"

export const getGrouping = (_, props) => get(props, "currentGrouping")

export const getGroupDropdown = createSelector(
  [getDataMap, getGrouping, getColumns, getSelectedGroup],
  (data, currentGroup, columns, selectedGroup) => {
    if (some([data, currentGroup, columns, selectedGroup], isEmpty)) {
      return null
    }

    const descriptors = chain(columns)
      .filter(({ category }) => isEmpty(category))
      .map(column => ({ ...column, getter: (item) => get(item, column.path) }))
      .value()

    return ({
      columns: [
        { id: "label", label: get(currentGroup, "label"), align: "left", getter: get },
        ...descriptors,
      ],
      items: map(data, (group) => ({
        ...group,
        // "Other" might be missing description, use name as fallback
        label: group.description ?? group.name,
      })),
      selectedId: selectedGroup,
      backAction: Creators.hideGroup(),
    })
  },
)
